// The Jira query builder (S88).
export default {
  quickStarts: "Quick starts",
  templates: {
    myOpenWork: { title: "My open work", body: "Assigned to me, not done, by priority" },
    unassignedBugs: { title: "Unassigned bugs", body: "Bugs to do that nobody has picked up" },
    labelledForAgents: { title: "Labelled for agents", body: "Anything labelled agent-ready" },
  },
  projects: "Projects",
  projectSearch: "Search your projects by key or name",
  projectKeyPlaceholder: "Type a project key, e.g. PAY",
  typeKeys: "Choose a secret above to pick from your Jira projects; until then, type keys and press Enter.",
  searching: "Searching…",
  lookupFailed: (message: string) => `Could not read Jira: ${message}`,
  remove: (value: string) => `Remove ${value}`,
  issueTypes: "Issue types",
  issueTypesHint: "None chosen means every type.",
  typeValue: "Type a value and press Enter",
  status: "Status",
  statusOptions: { notDone: "Not done", toDo: "To do only", pick: "Choose…" },
  statuses: "Statuses",
  statusesHint: "Issues in any of these statuses.",
  assignee: "Assigned to",
  assigneeOptions: { me: "Me", anyone: "Anyone", unassigned: "Nobody" },
  labels: "Labels",
  labelPlaceholder: "Type a label",
  labelsHint: "Issues with any of these labels; none means any label.",
  order: "Order",
  orderOptions: { priority: "Highest priority first", created: "Oldest first", updated: "Recently updated first", none: "Jira's default" },
  activeSprint: "Only the active sprint",
  includeSubtasks: "Include sub-tasks of matching issues",
  includeSubtasksHint: "Sub-tasks assigned to you that aren't done, even when their own fields (like Sprint) don't match.",
  subtasksIncluded: "Plus your open sub-tasks of matching issues",
  jql: "JQL",
  editJql: "Edit JQL",
  useBuilder: "Use the builder",
  rawHint: "Any JQL works here. Issues in a done status count as closed.",
  cannotBuild: "This query says more than the builder can show, so it stays as JQL.",
  emptyJql: "Choose a project to start the query.",
};
